import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

export default class Text extends React.Component {

    static propTypes = {
        text: PropTypes.string.isRequired,
        properties: PropTypes.object.isRequired,
        classes: PropTypes.object,
        editing: PropTypes.bool,
    };

    static defaultProps = {
        editing: false,
    };

    render()
    {
        const className = classNames({
            'flex items-center text-gray-600 h-full outline-none whitespace-pre-wrap box-border': true,
            'break-words overflow-hidden text-center': true
        });

        const containerStyle = {
            backgroundColor: this.props.properties.backgroundColor || null
        }

        const style = {
            padding: parseInt(this.props.properties.padding) || 0,
            fontSize: parseInt(this.props.properties.fontSize) || 30,
            color: this.props.properties.color || null
        };

        if ('fontFamily' in this.props.properties) {
            style.fontFamily = this.props.properties.fontFamily;
        }

        const wrapStyles = {
            'w-full': true,
            'text-left': this.props.properties.alignment === 'left',
            'text-right': this.props.properties.alignment === 'right',
            'text-center': this.props.properties.alignment === 'center'
        };

        if ('styles' in this.props.properties) {
            wrapStyles['font-bold'] = this.props.properties.styles.includes('bold');
            wrapStyles['italic'] = this.props.properties.styles.includes('italic');
            wrapStyles['underline'] = this.props.properties.styles.includes('underline');
        }

        const wrapClasses = classNames(wrapStyles);

        return <div className={className} style={containerStyle}>
            <div className={wrapClasses} style={style}>
                {this.props.text}
            </div>
        </div>;
    }
}
